import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import Img from 'gatsby-image';
import Content from 'components/basics/Content';
import ExplanationsText from 'components/pages/Solution/Marketing/ExplanationsBlock/ExplanationsText';
import BlockButtonTestQemotion from 'components/BlockTestQemotion/BlockButtonTestQemotion';
import TitleExplanationsBlock from 'components/pages/Solution/Marketing/ExplanationsBlock/TitleExplanationsBlock';

const StyledGrid = styled(Grid)`
  ${Content}
`;
const StyledImg = styled(Img)`
  width: 100%;
  max-width: 500px;
`;
const GridImage = styled(Grid)`
  padding: 2rem;
`;
const GridButton = styled(Grid)`
  padding-top: 2rem;
`;

const ExplanationsBlock = ({ data, lang }) => {
  return (
    <Grid container justify="center">
      <TitleExplanationsBlock data={data} />
      <StyledGrid container justify="center">
        <GridImage item xs={10} sm={7} md={5} lg={5}>
          <StyledImg fluid={data.image.childImageSharp.fluid} />
          <GridButton>
            <BlockButtonTestQemotion lang={lang} justifyContent={'center'} />
          </GridButton>
        </GridImage>
        <ExplanationsText data={data} />
      </StyledGrid>
    </Grid>
  );
};
export default ExplanationsBlock;
